"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var money_1 = require("./money");
var price = {
    PRICE: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    fragment Price on Price {\n      money {\n        ...Money\n      }\n      type\n      taxes {\n        money {\n          ...Money\n        }\n        aggregated\n        type\n        label\n      }\n    }\n  "], ["\n    ", "\n    fragment Price on Price {\n      money {\n        ...Money\n      }\n      type\n      taxes {\n        money {\n          ...Money\n        }\n        aggregated\n        type\n        label\n      }\n    }\n  "])), money_1.default.MONEY),
};
exports.default = price;
var templateObject_1;
